$(function(){
  $('.u_accordian_head').click(function(){               
                if($(this).next().hasClass('active'))
                {
                    $(this).next().removeClass('active').hide();
                    $(this).find('.u_icon i').addClass('fa-plus').removeClass('fa-minus');
                }
                else{
            $(this).next('.u_accordian_body').addClass('active').show();
            $(this).find('.u_icon i').addClass('fa-minus').removeClass('fa-plus');
                }
            })
  // $(window).on('load',function(){
  //   console.log('load')
  //   $('.u_collection_template .grid__item .card__media').addClass('u_animate')
  // })
            })